<template>
  <div class="ad-automate">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="应用对象" name="first">
        <application @cutTab="handleTab" ref="applicationRef"></application>
      </el-tab-pane>
      <el-tab-pane label="自动规则模版" name="second">
        <ruleTemplate ref="ruleRef" />
      </el-tab-pane>
      <el-tab-pane label="分时策略模版" name="third">
        <adjust></adjust>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import ruleTemplate from './components/rule-template';
import application from './application';
import adjust from '@/views/modules/ad/strategy/time-adjust/time-adjust-strategy.vue';
export default {
  name: 'ad-automate',
  components: { ruleTemplate, application, adjust },
  data() {
    return {
      activeName: 'first',
    };
  },
  activated() {
    if (this.$route.query.refresh === 'Refresh' && this.$route.query.tabKey) {
      // 进行刷新
      console.log('全部刷新')
      this.$refs.applicationRef.$gjQuery();
      this.$refs.ruleRef.$gjQuery();
    } else if(this.$route.query.tabKey === '1') {
      console.log('刷新应用对象')
      this.$refs.applicationRef.$gjQuery();
    } else if (this.$route.query.tabKey === '2') {
      console.log('刷新自动模板规则')
      this.$refs.ruleRef.$gjQuery();
    }
    this.$router.push('/ad/ad-automate');
  },
  methods: {
    handleClick(tab, event) {

    },
    // 引导页切换
    handleTab() {
      this.activeName = 'second';
      this.$refs.ruleRef.resize();
    }
  },
};
</script>
<style scoped lang="scss">
.ad-automate {
  box-sizing: border-box;
  height: 100%;
  background: white;
  padding: 6px 16px 16px 16px;
  /deep/ .el-tabs {
    height: 100%;
    display: flex;
    flex-direction: column;

    .el-tabs__content {
      flex: 1;
      overflow: auto;
      .el-tab-pane {
        height: 100%;
      }
    }
  }
  /deep/.el-tabs__item {
      padding: 0 16px;
    }

}

</style>
